import { render, staticRenderFns } from "./rowTable.vue?vue&type=template&id=21844ea5&"
import script from "./rowTable.vue?vue&type=script&lang=js&"
export * from "./rowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports